import sample_01 from './exclusivGlas.jpg';

export const exclusiveGlasImpressions = {
    sample_01,
};
